<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-flex xs12>
        <v-toolbar class="elevation-2">
          <v-row dense class="mt-4">
            <v-col cols="12" sm="6" md="4">
              <SelectedGroupDinamicField :itemAction="selectedDepartamento" :on-success="actionFieldData" />
            </v-col>
          </v-row>
          <v-spacer></v-spacer>
        </v-toolbar>
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
        <v-row dense>
          <v-col class="12">
            <v-layout justify-center>
              <v-flex xs12 sm11>
                <ViewDetails class="ma-2" :object="object" type="HorarioColaborador" :itemsAction="tableAction"/>
              </v-flex>
            </v-layout>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <MainFormDialog v-if="get_dialogMain.dialog" :fields="form" :model="objectMain" :urls="url" :message="message" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import MainFormDialog from '@/components/dialogs/MainFormDialog'
import SelectedGroupDinamicField from '@/components/fields/SelectedGroupDinamicField'

import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'

export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' },
          { title: 'Nuevo', icon: 'mdi-plus', color: 'success', action: 'newData', code: 'libre', hidden: '' },
          { title: 'Importar', icon: 'mdi-database-import', color: 'blue-grey darken-1', action: 'importData', code: 'asist.horario-create-layout' }
        ],
        titles: [
          { text: 'Cve Empleado', value: 'adscripcion.empleado.cve_empleado', class: 'black--text' },
          { text: 'Nombre Empleado', value: 'adscripcion.empleado.NombreCompleto', class: 'black--text' },
          { text: 'Departamento', value: 'adscripcion.departamento.nombre', class: 'black--text' },
          { text: 'Total de Horas', value: 'total_horas', class: 'black--text' },
          { text: 'Ejercicio', value: 'ejercicio.descripcion', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
          // { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    selectedDepartamento: {
      field: 'selectGroupDataServer',
      name: 'Departamentos',
      nameid: 'cct',
      url: '/config/departamentos/show',
      itemvalue: 'clave',
      rules: true,
      cols: 12
    },
    params: {},
    form: [],
    objectMain: {},
    url: {},
    message: ''
  }),
  components: {
    DataTableMain,
    SelectedGroupDinamicField,
    MainFormDialog,
    ViewDetails
  },
  mounted () {
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
    this.getUrl('POST/asistencia/horario/show')
  },
  methods: {
    ...mapActions(['getUrlServices', 'postServiceListAction', 'putServiceAction']),
    ...mapMutations(['SHOW_DIALOG_MAIN', 'CLEAR_DATA_LIST', 'SET_DATA']),

    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.getUrl('POST/asistencia/horario/show')
    },
    newData (item) {
      this.form = this.get_horarioColaboradorForm
      this.objectMain = {}
      this.url = this.get_urls['POST/asistencia/horario/store']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Nuevo Horario' })
    },
    importData (item) {
      this.object = {}
      this.form = this.get_fileIncidencia
      this.url = this.get_urls['POST/asistencia/resumen-horas/importar']
      this.message = 'Importacion Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'fileSend', with: 950, title: 'Importar Incidencia', body: { content: 'form-data' } })
    },

    newHorarioData (item) {
      this.form = this.get_horarioDiaForm
      this.objectMain = { horario_id: item.item.id, dia: [] }
      this.url = this.get_urls['POST/asistencia/horario/dias/store']
      this.message = 'Registro Agregado Correctamente'
      this.SHOW_DIALOG_MAIN({ type: 'create', with: 850, title: 'Agregar Horario del Dia' })
    },
    tableAction (item) {
      this[item.action](item)
    },
    deleteHorarioData ({ item, body }) {
      console.log('deleteHorarioData', body)
      this.$swal.fire({
        title: 'Estas seguro de eliminar el registro ?',
        text: 'No podras revertir este movimiento!',
        icon: 'warning',
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Si, Eliminar!',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          const router = this.get_urls['PUT/asistencia/horario/dias/{id}']
          this.putServiceAction({ url: router, data: body, replace: '{id}', params: item.id })
        }
      })
    },

    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postServiceListAction({ url: router, data: this.params })
      } else {
        this.getUrlServices()
      }
    },
    actionFieldData (obj) {
      this.params[obj.id] = (obj.data) ? obj.data : null
      this.table.header.loading = true
      this.getUrl('POST/asistencia/horario/show')
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_objects', 'get_object',
      'get_horarioColaboradorForm', 'get_horarioDiaForm']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_urls (val) {
      this.getUrl('POST/asistencia/horario/show')
    },
    get_objects (vals) {
      if (vals) {
        this.table.modelMain = []
        if (vals.length > 0) {
          this.table.modelMain.push(vals[0])
        }
        this.table.header.loading = false
        this.table.body.data = vals
      }
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro Actualizado Correctamente'
      })
      this.SET_DATA(val)
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_LIST()
  }
}
</script>

<style>

</style>
